import { ClockIcon } from "@heroicons/react/24/outline";
import { FC } from "react";
import { Link } from "react-router-dom";
import IconBtn from "../ui/IconBtn";
import SuperAdmin from "../users/permissions/SuperAdmin";

interface IHistoryIconLink {
  // The entity's CLR name on the backend, e.g. `Review` or `GTFSStop`.
  entityName: string;
  entityId: string | number | undefined;
}

// A clock icon in a list's actions cell that opens the row's change history. SuperAdmins only.
const HistoryIconLink: FC<IHistoryIconLink> = ({ entityName, entityId }) => {
  if (!entityId) return null;
  return (
    <SuperAdmin>
      <Link
        to={`/change-history?entityName=${encodeURIComponent(entityName)}&entityId=${entityId}`}
        state={["Historiku i ndryshimeve"]}
        title="Historiku i ndryshimeve"
        className="inline-flex"
      >
        <IconBtn className="w-6 h-6 text-neutral select-none">
          <ClockIcon className="w-4 h-4" />
        </IconBtn>
      </Link>
    </SuperAdmin>
  );
};

export default HistoryIconLink;
